<template>
  <div>
    <Navbar />
    <div class="container">

      <section class="top-hero-section">
        <div class="top-hero-shell">
          <div class="top-hero-left">
            <p class="top-hero-line top-hero-line-1">We are NOT</p>
            <h1 class="top-hero-headline">BUYER'S AGENT</h1>
            <p class="top-hero-tagline">Norland Advisory, is your</p>
            <p class="top-hero-headline top-hero-headline-2">PORTFOLIO PARTNER</p>
          </div>

          <div class="top-hero-right">
            <div class="hero-couple-card">
              <img src="/images/lemonandray.jpg" alt="Lemon Xu and Ray Liu" loading="eager" class="hero-couple-photo" />
              <!-- <div class="hero-couple-meta">
                <h2 class="hero-couple-title">Our Story &amp; Our Vision</h2>
                <router-link to="/contact" class="hero-action-btn hero-discovery-btn">Free Discovery Call</router-link>
              </div> -->
            </div>
          </div>
        </div>
      </section>

      <section class="our-story-section">
        <div class="our-story-shell">
          <header class="our-story-header">
            <p class="our-story-kicker">Our Story &nbsp;·&nbsp; 我们的故事</p>
          </header>

          <div class="our-story-body">
            <div class="our-story-en">
              <!-- <h2>Our Story</h2> -->
              <p>
                Over the years, we've walked through more than 1,000 properties alongside our clients and partners.
                Many of them started out in remarkably similar circumstances — but because they bought different homes,
                their wealth and their lives took completely different paths.
              </p>
              <p>Among them are:</p>
              <ul>
                <li>Gen Z first-time buyers, fresh out of school, who had just saved up their down payment;</li>
                <li>Middle-class couples earning $300k combined, hoping to leave something meaningful for their children;</li>
                <li>Entrepreneurs and business owners earning seven figures a year, looking to turn years of hard-earned income into real, lasting assets.</li>
              </ul>
              <p>
                After witnessing so many families, so many homes, and so many different stories, we know — with clarity
                and conviction — which properties are worth buying, and which ones aren't.
              </p>
              <p>
                That experience has shaped a proven, mature framework for building investment property portfolios —
                one we've refined deal by deal, year after year.
              </p>
            </div>

            <div class="our-story-zh">
              <!-- <h2>我们的故事</h2> -->
              <p>
                过去这些年，我们看过超过1000套客户和小伙伴的房子，他们最初拥有相似的境遇，
                但是因为买的房子不一样，他们的财富和人生走上了完全不同的道路。
              </p>
              <p>这些客户里，常见的就有：</p>
              <ul>
                <li>刚步入社会、攒下第一笔首付的年轻人；</li>
                <li>夫妻年收入30万，希望为孩子和家庭提前打基础的中产家庭；</li>
                <li>年入百万的创业者和企业家，想把多年辛苦赚来的现金流沉淀成长期资产的人群。</li>
              </ul>
              <p>
                见证了这么多家庭、这么多房子、这么多不同的故事——
                我们深刻地清楚，什么房子能买，什么房子不能买。
              </p>
              <p>
                这些经验也让我们沉淀出一整套经过验证、并在实战中持续迭代的投资组合搭建体系。
              </p>
            </div>
          </div>

          <div class="our-story-cta">
            <button type="button" class="our-story-btn" @click="openDiscoveryModal">Free Discovery Call</button>
          </div>
        </div>
      </section>

      <!-- <section class="hotspotting-support-section">
        <div class="hotspotting-shell">
          <div class="hotspotting-header">
            <p>Supported by Hotspotting.com.au</p>
            <h2>Market Insight Partner</h2>
            <span>Independent research support from the Hotspotting leadership team, strengthening location analysis and timing decisions.</span>
            <a class="hotspotting-logo" href="https://www.hotspotting.com.au/" target="_blank" rel="noopener noreferrer" aria-label="Visit Hotspotting website">
              <img src="https://www.hotspotting.com.au/assets/hotspotting-logo/Hotspotting.%20logo%2020%20years-01.png" alt="Hotspotting logo" loading="lazy" />
            </a>
          </div>

        </div>
      </section> -->
      <!--
      <section class="split-section">
        <div class="section-container">
          <div class="split-left">
            <span class="split-tag">Property Advisory</span>
            <h2>Clear Direction for Your Investment Journey</h2>
            <p>
              Through strategic research, asset selection, and end-to-end execution,
              we help you build your portfolio efficiently while reducing decision risk.
            </p>
            <button class="split-btn">Free Consultation</button>
          </div>
          <div class="split-right">
            <div class="info-card">
              <h3>This Week's Quick Insights</h3>
              <p>Three high-potential suburbs with yield ratios and migration trend highlights.</p>
              <ul>
                <li>Suburb growth data</li>
                <li>Cashflow model reference</li>
                <li>Entry timing suggestions</li>
              </ul>
            </div>
          </div>
        </div>
      </section> -->

      <!-- <section class="split-section split-section-alt">
        <div class="section-container">
          <div class="split-left">
            <span class="split-tag">Property Advisory</span>
            <h2>Clear Direction for Your Investment Journey</h2>
            <p>
              Through strategic research, asset selection, and end-to-end execution,
              we help you build your portfolio efficiently while reducing decision risk.
            </p>
            <button class="split-btn">Free Consultation</button>
          </div>
          <div class="split-right">
            <div class="info-card">
              <div class="nectar-blocks-video-player__video display-desktop">
                <video class="nectar-aspect-ratio nectar-aspect-ratio--1-1" autoplay="" playsinline="" muted="" preload="metadata" loop="" controls="">
                  <source type="video/mp4" src="https://cdn.investorkit.com.au/wp-content/uploads/2026/02/30-Sec-Video.mp4">
                </video>
              </div>
            </div>
          </div>
        </div>
      </section> -->

      <!-- <section class="offer-section">
        <div class="offer-shell">
          <div class="offer-image-wrap">
            <img class="offer-image" src="/images/ourservices.png" alt="Our services" loading="lazy" />
          </div>
        </div>
      </section> -->

      <section class="numbers-section">
        <div class="numbers-shell">
          <div class="numbers-left">
            <p class="numbers-kicker">TRACK RECORD ACROSS {{ displayPropertyCount }} PORTFOLIOS</p>
            <h2 class="numbers-title">Let the Results<br><span>Speak</span></h2>

            <div class="numbers-grid">
              <article class="metric-card">
                <p>TOTAL PROPERTIES</p>
                <h3>{{ numbersStats.totalProperties }}</h3>
              </article>
              <article class="metric-card">
                <p>AVG PURCHASE PRICE</p>
                <h3>{{ formatStatMoney(numbersStats.avgPurchasePrice) }}</h3>
              </article>
              <!-- <article class="metric-card">
                <p>TOTAL ASSET UNDER MGT</p>
                <h3>{{ formatStatCompactMoney(numbersStats.totalAum) }}</h3>
              </article> -->
              <article class="metric-card"><!--metric-wide-->
                <p>MEDIAN rental yield</p>
                <h3>{{ formatStatNumber(numbersStats.avgRentalYield, 2) }}%</h3>
              </article>
              <article class="metric-card">
                <p>MEDIAN Annual Growth</p>
                <h3>{{ formatStatNumber(numbersStats.medianAnnualCapitalGainRate, 2) }}%</h3>
              </article>
            </div>

            <div class="chart-disclaimer chart-disclaimer-left">
              <p class="chart-disclaimer-heading">Important &mdash; historical data, not a forecast</p>
              <p class="chart-disclaimer-body">Figures shown are historical transaction results for individual past Norland Advisory clients. &ldquo;Current value&rdquo; is an internal estimate, not a formal valuation. Yield calculations exclude loan interest, land tax, council rates, insurance,
                depreciation, maintenance, vacancy, and personal tax. The reference line on the chart is illustrative only &mdash; it is not a regression, trend fit, or forecast. Past performance is not a reliable indicator of future results; property prices can fall as well as rise. Nothing on this
                page is personal financial advice. <router-link to="/disclaimer">Read the full disclaimer.</router-link></p>
            </div>
          </div>

          <div class="numbers-right">
            <ScatterChart :series="numbersStats.capitalGainVsTenure" />
          </div>
        </div>
      </section>

      <section class="sales-team-section">
        <div class="sales-team-shell">
          <header class="sales-team-header">
            <h2>Your Portfolio Partners</h2>
          </header>

          <div class="sales-team-list">
            <article v-for="member in salesConsultants" :key="member.name" class="consultant-card">
              <div class="consultant-photo-wrap">
                <img class="consultant-photo" :src="member.photo" :alt="`${member.name} portrait`" loading="lazy" />
              </div>
              <div class="consultant-content">
                <h3>{{ member.name }}</h3>
                <p class="consultant-role">{{ member.role }}</p>
              </div>
            </article>
          </div>
        </div>
      </section>

      <!-- <section class="report-section">
        <div class="report-shell">
          <div class="report-left">
            <p class="report-kicker">Research Reports</p>
            <h2>Request Research Report Downloads</h2>
            <p class="report-intro">
              Access our latest market research, suburb comparisons, and strategy briefings.
              Select your topic and submit the form to receive the download link.
            </p>

            <div class="report-list">
              <article v-for="report in researchReports" :key="report.title" class="report-item">
                <div>
                  <h3>{{ report.title }}</h3>
                  <p>{{ report.summary }}</p>
                  <span>{{ report.meta }}</span>
                </div>
                <button type="button" class="report-apply-btn" @click="selectReport(report.title)">Request Download</button>
              </article>
            </div>
          </div>

          <div class="report-right">
            <form class="report-form" @submit.prevent="submitReportRequest">
              <h3>Submit Details to Receive the Link</h3>

              <label>
                Name
                <input v-model.trim="reportForm.name" type="text" placeholder="Enter your name" required />
              </label>

              <label>
                Email
                <input v-model.trim="reportForm.email" type="email" placeholder="name@email.com" required />
              </label>

              <label>
                Company / Role
                <input v-model.trim="reportForm.company" type="text" placeholder="e.g. Private Investor / Company Name" />
              </label>

              <label>
                Select Report
                <select v-model="reportForm.report" required>
                  <option disabled value="">Please select a report</option>
                  <option v-for="report in researchReports" :key="`opt-${report.title}`" :value="report.title">{{ report.title }}</option>
                </select>
              </label>

              <label>
                Notes
                <textarea v-model.trim="reportForm.note" rows="3" placeholder="Add target areas or budget range (optional)"></textarea>
              </label>

              <button type="submit" class="report-submit-btn">Submit Request</button>
              <p v-if="reportSubmitted" class="report-success">Request submitted. We will email your download link shortly.</p>
            </form>
          </div>
        </div>
      </section> -->

      <section class="page-hero">
        <h1>Norland Advisory</h1>
        <p>Your Portfolio Expert & Partner</p>
        <el-button type="primary" size="large" class="hero-cta" @click="openDiscoveryModal">Book Consultation</el-button>
      </section>


    </div>
    <SiteFooter />

    <!-- Discovery Call Modal -->
    <transition name="modal-fade">
      <div v-if="discoveryModal.open" class="dc-overlay" @click.self="closeDiscoveryModal" role="dialog" aria-modal="true" aria-labelledby="dc-title">
        <div class="dc-dialog">
          <button class="dc-close" @click="closeDiscoveryModal" aria-label="Close">&times;</button>

          <div class="dc-header">
            <p class="dc-kicker">Free Discovery Call</p>
            <h2 id="dc-title">Book Your Free Discovery Call</h2>
            <p class="dc-sub">Fill in your details below and we'll reach out to schedule a call at a time that works for you.</p>
          </div>

          <form class="dc-form" @submit.prevent="submitDiscoveryCall">
            <div class="dc-row">
              <label class="dc-field">
                <span>Name <span class="dc-req">*</span></span>
                <input v-model.trim="discoveryForm.name" type="text" placeholder="Your full name" required />
              </label>
              <label class="dc-field">
                <span>Phone <span class="dc-req">*</span></span>
                <input v-model.trim="discoveryForm.phone" type="tel" placeholder="e.g. 0400 000 000" required />
              </label>
            </div>

            <label class="dc-field">
              <span>Email <span class="dc-req">*</span></span>
              <input v-model.trim="discoveryForm.email" type="email" placeholder="name@email.com" required />
            </label>

            <div class="dc-row">
              <label class="dc-field">
                Best Time to Call
                <select v-model="discoveryForm.callTime">
                  <option value="">No preference</option>
                  <option>Morning (9am – 12pm)</option>
                  <option>Afternoon (12pm – 5pm)</option>
                  <option>Evening (5pm – 8pm)</option>
                </select>
              </label>
              <label class="dc-field">
                Investment Budget
                <select v-model="discoveryForm.budget">
                  <option value="">Prefer not to say</option>
                  <option>Under $500K</option>
                  <option>$500K – $800K</option>
                  <option>$800K – $1.2M</option>
                  <option>$1.2M – $2M</option>
                  <option>$2M+</option>
                </select>
              </label>
            </div>

            <label class="dc-field">
              Your Enquiry
              <textarea v-model.trim="discoveryForm.enquiry" rows="4" placeholder="Tell us about your goals, current situation, or any questions you have..."></textarea>
            </label>

            <div v-if="discoveryModal.error" class="dc-error">{{ discoveryModal.error }}</div>

            <button type="submit" class="dc-submit" :disabled="discoveryModal.submitting">
              <span v-if="discoveryModal.submitting">Sending…</span>
              <span v-else>Send Request</span>
            </button>
          </form>

          <div v-if="discoveryModal.success" class="dc-success">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10" />
              <polyline points="9 12 11 14 15 10" />
            </svg>
            <div>
              <strong>Request received!</strong>
              <p>Thank you, {{ discoveryModal.submittedName }}. Our team will contact you shortly to confirm your discovery call.</p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import SiteFooter from '@/components/layout/SiteFooter.vue';
import Navbar from '@/components/layout/Navbar.vue';
import ScatterChart from '@/components/ScatterChart.vue';
import { pubStoreSpecAction } from '@/api/apiService';
import env from '@/api/env';

const storeId = env.storeId;

export default {
  components: { SiteFooter, Navbar, ScatterChart },
  created() {
    this.fetchTotalStats();
  },
  data() {
    return {
      numbersStats: {
        propertyCount: 200,
        avgPurchasePrice: 720117,
        avgRentalYield: 5.74,
        avgWeeklyRent: 866,
        avgLandSize: 689,
        annualCapitalGain: 13.46,
        totalProperties: 241000000,
        totalPassiveIncome: 54000000,
        leveragedAnnualizedReturn: 40.52,
        totalAum: 295000000,
        capitalGainVsTenure: [
          2, 4, 6, 8, 10, 12, 14, 16,
          18, 20, 22, 25, 28, 31, 34, 37,
          40, 44, 48, 52, 56, 60, 64, 68
        ]
      },
      salesConsultants: [
        {
          name: 'Ray Liu',
          role: 'Founder & Executive Director',
          photo: '/images/rayliut2.jpg'
        },
        {
          name: 'Lemon Xu',
          role: 'Founder & Managing Director',
          photo: '/images/lemont1.jpg'
        },
        {
          name: 'Terry Ryder',
          role: 'Founder, Hotspotting',
          photo: '/images/terryryder.jpg'
        },
        {
          name: 'Tim Graham',
          role: 'General Manager, Hotspotting',
          photo: '/images/timgraham.jpg'
        }
      ],
      researchReports: [
        {
          title: '2026 Australia Growth Corridor Outlook',
          summary: 'Breaks down jobs, infrastructure, and migration trends across major growth corridors.',
          meta: 'PDF | 48 pages | Updated Feb 2026'
        },
        {
          title: 'Rental Yield Heatmap Quarterly Brief',
          summary: 'Covers rental-yield heatmaps and supply-demand shifts in key metropolitan markets.',
          meta: 'PDF | 26 pages | Q1 2026'
        },
        {
          title: 'Buyer Negotiation Playbook',
          summary: 'Summarizes common negotiation scenarios and contract-term optimization tactics.',
          meta: 'PDF | 19 pages | Practice Guide'
        }
      ],
      reportForm: {
        name: '',
        email: '',
        company: '',
        report: '',
        note: ''
      },
      reportSubmitted: false,
      discoveryModal: {
        open: false,
        submitting: false,
        success: false,
        error: '',
        submittedName: ''
      },
      discoveryForm: {
        name: '',
        phone: '',
        email: '',
        callTime: '',
        budget: '',
        enquiry: ''
      }
    }
  },
  computed: {
    displayPropertyCount() {
      const count = Math.max(0, Math.round(this.toNumber(this.numbersStats.propertyCount, 0)));
      return count > 0 ? `${count}+` : '0';
    },
  },
  methods: {
    async fetchTotalStats() {
      try {
        const ret = await pubStoreSpecAction(storeId, 'pubGetTotalStats', {});
        this.numbersStats = this.normalizeTotalStats(ret);
      } catch(error) {
        console.error('Failed to load total stats by pubStoreSpecAction:', error);
      }
    },
    normalizeTotalStats(source) {
      const raw = source && typeof source === 'object'
        ? (source.data && typeof source.data === 'object' ? source.data : source)
        : {};
      return {
        propertyCount: this.toNumber(this.pick(raw, ['propertyCount', 'totalProperties', 'totalPropertyCount', 'portfolioCount']), this.numbersStats.propertyCount),
        avgPurchasePrice: this.toNumber(this.pick(raw, ['avgPurchasePrice', 'avg_purchase_price', 'purchasePriceAvg']), this.numbersStats.avgPurchasePrice) / 100,
        avgRentalYield: this.toNumber(this.pick(raw, ['avgRentalYield', 'avg_rental_yield', 'rentalYieldAvg']), this.numbersStats.avgRentalYield),
        avgWeeklyRent: this.toNumber(this.pick(raw, ['avgWeeklyRent', 'avg_weekly_rent', 'weeklyRentAvg']), this.numbersStats.avgWeeklyRent),
        avgLandSize: this.toNumber(this.pick(raw, ['avgLandSize', 'avg_land_size', 'landSizeAvg']), this.numbersStats.avgLandSize),
        medianAnnualRentalYield: this.toNumber(this.pick(raw, ['medianAnnualRentalYield']), this.numbersStats.medianAnnualRentalYield),
        medianAnnualCapitalGainRate: this.toNumber(this.pick(raw, ['medianAnnualCapitalGainRate']), this.numbersStats.medianAnnualCapitalGainRate),
        totalProperties: this.toNumber(this.pick(raw, ['totalProperties', 'total_properties', 'propertyCount']), this.numbersStats.totalProperties),
        annualCapitalGainRate: this.toNumber(this.pick(raw, ['annualCapitalGainRate']), this.numbersStats.annualCapitalGainRate),
        totalPassiveIncome: this.toNumber(this.pick(raw, ['totalPassiveIncomeGenerated']), this.numbersStats.totalPassiveIncome),
        leveragedAnnualizedReturn: this.toNumber(this.pick(raw, ['leveragedAnnualizedReturn', 'leveraged_annualized_return']), this.numbersStats.leveragedAnnualizedReturn),
        totalAum: this.toNumber(this.pick(raw, ['totalAum', 'totalAUM', 'aum', 'totalAssetUnderManagement']), this.numbersStats.totalAum),
        capitalGainVsTenure: this.normalizeGainSeries(this.pick(raw, ['accumulatedCapitalGainVsTenurePeriod']))
      };
    },
    normalizeGainSeries(source, fallback = []) {
      const list = Array.isArray(source)
        ? source
        : (source && typeof source === 'object'
          ? Object.entries(source).map(([key, value]) => ({ tenure: key, gain: value }))
          : []);

      const normalized = list
        .map((item, index) => {
          if(typeof item === 'number' || typeof item === 'string') {
            return {
              x: index + 1,
              y: this.toNumber(item, NaN)
            };
          }

          if(item && typeof item === 'object') {
            const x = item.holdingYears;
            const y = item.percentage;
            return { x, y, prop: item.prop };
          }

          return { x: index + 1, y: NaN };
        })
        .filter((point) => Number.isFinite(point.x) && Number.isFinite(point.y));

      if(normalized.length) {
        return normalized;
      }

      if(Array.isArray(fallback)) {
        return fallback
          .map((value, index) => ({ x: index + 1, y: this.toNumber(value, NaN), prop: value.prop }))
          .filter((point) => Number.isFinite(point.y));
      }

      return [];
    },
    pick(source, keys) {
      for(let i = 0; i < keys.length; i += 1) {
        const value = source[keys[i]];
        if(value !== undefined && value !== null && value !== '') {
          return value;
        }
      }

      return undefined;
    },
    toNumber(value, fallback = 0) {
      if(typeof value === 'number' && Number.isFinite(value)) {
        return value;
      }

      if(typeof value === 'string') {
        const parsed = Number(value.replace(/[^\d.-]/g, ''));
        return Number.isFinite(parsed) ? parsed : fallback;
      }

      return fallback;
    },
    formatStatMoney(value) {
      const num = this.toNumber(value, 0);
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
        maximumFractionDigits: 0
      }).format(num);
    },
    formatStatCompactMoney(value) {
      const num = this.toNumber(value, 0);
      if(num >= 1000000) {
        return `$${Math.round(num / 1000000)}m`;
      }

      return this.formatStatMoney(num);
    },
    formatStatNumber(value, decimals = 2) {
      const num = this.toNumber(value, 0);
      return num.toLocaleString('en-AU', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      });
    },
    selectReport(title) {
      this.reportForm.report = title
      this.reportSubmitted = false
    },
    submitReportRequest() {
      if(!this.reportForm.name || !this.reportForm.email || !this.reportForm.report) {
        return
      }

      this.reportSubmitted = true
      this.reportForm = {
        name: '',
        email: '',
        company: '',
        report: '',
        note: ''
      }
    },
    openDiscoveryModal() {
      this.discoveryModal.open = true
      this.discoveryModal.success = false
      this.discoveryModal.error = ''
      document.body.style.overflow = 'hidden'
    },
    closeDiscoveryModal() {
      this.discoveryModal.open = false
      document.body.style.overflow = ''
    },
    async submitDiscoveryCall() {
      if(!this.discoveryForm.name || !this.discoveryForm.phone || !this.discoveryForm.email) {
        this.discoveryModal.error = 'Please fill in your name, phone and email.'
        return
      }
      this.discoveryModal.error = ''
      this.discoveryModal.submitting = true
      try {
        await pubStoreSpecAction(storeId, 'submitClientReq', {
          type: 'callback',
          name: this.discoveryForm.name,
          phone: this.discoveryForm.phone,
          email: this.discoveryForm.email,
          callTime: this.discoveryForm.callTime,
          budget: this.discoveryForm.budget,
          enquiry: this.discoveryForm.enquiry
        })
      } catch(e) {
        // best-effort; proceed to success state regardless
      } finally {
        this.discoveryModal.submitting = false
      }
      this.discoveryModal.submittedName = this.discoveryForm.name
      this.discoveryModal.success = true
      this.discoveryForm = { name: '', phone: '', email: '', callTime: '', budget: '', enquiry: '' }
    }
  }
}
</script>

<style scoped>
.container {
  margin: 0 auto;
  padding-top: 118px;
  --c-bg-soft: #f1f7f5;
  --c-bg-warm: #eef6f3;
  --c-bg-alt: #e9f3f0;
  --c-primary: #2f7a6c;
  --c-primary-deep: #1e5f53;
  --c-accent: #7bb5a8;
  --c-accent-soft: #b8dcd4;
  --c-text-strong: #2f4c45;
  --c-text-body: #5e7972;
  --c-text-muted: #7b918b;
  --c-card: #ffffff;
  --c-card-border: #d2e3de;
  --c-card-soft: #e7f1ee;
  --c-on-dark: #edf8f5;
  --c-on-dark-muted: rgba(237, 248, 245, 0.76);
  --c-dark-1: #0b4f47;
  --c-dark-2: #136456;
  --c-dark-3: #1c7a67;
}

.top-hero-section {
  position: relative;
  min-height: clamp(460px, 72vh, 820px);
  display: flex;
  align-items: center;
  padding: clamp(36px, 5vw, 64px) clamp(16px, 5vw, 5%);
  background-image:
    linear-gradient(155deg, rgba(5, 17, 20, 0.78), rgba(8, 21, 18, 0.62)),
    url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=2200&q=80');
  background-size: cover;
  background-position: center;
  overflow: hidden;
}

.top-hero-shell {
  position: relative;
  z-index: 1;
  width: min(1280px, 100%);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(340px, 1fr);
  gap: clamp(28px, 4.5vw, 64px);
  align-items: center;
}

.top-hero-left {
  display: grid;
  gap: clamp(14px, 1.6vw, 24px);
  color: var(--c-on-dark);
}

.top-hero-line {
  margin: 0;
  line-height: 1.1;
}

.top-hero-line-1 {
  font-size: clamp(1.05rem, 1.7vw, 1.55rem);
  font-weight: 500;
  color: rgba(243, 250, 248, 0.92);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.top-hero-headline {
  margin: 0;
  font-size: clamp(2.2rem, 4.8vw, 3.8rem);
  line-height: 1.05;
  font-weight: 900;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  color: #f2fcf8;
  text-shadow: 0 8px 24px rgba(5, 18, 15, 0.35);
}

.top-hero-headline-2 {
  position: relative;
  padding-left: clamp(14px, 1.4vw, 22px);
}

.top-hero-headline-2::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.18em;
  bottom: 0.18em;
  width: 4px;
  border-radius: 2px;
  background: var(--c-accent, #7bb5a8);
}

.top-hero-tagline {
  margin: 0;
  max-width: 560px;
  font-size: clamp(1.05rem, 1.7vw, 1.55rem);
  font-weight: 500;
  line-height: 1.35;
  color: rgba(243, 250, 248, 0.9);
}

.top-hero-right {
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.hero-couple-card {
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid rgba(194, 225, 216, 0.35);
  background: linear-gradient(180deg, rgba(14, 52, 44, 0.74), rgba(10, 40, 34, 0.84));
  box-shadow: 0 22px 48px rgba(5, 22, 18, 0.45), 0 2px 8px rgba(5, 22, 18, 0.25);
  max-width: min(100%, 680px);
  width: 100%;
  transform: translateZ(0);
}

.hero-couple-card::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  pointer-events: none;
  background: linear-gradient(180deg, rgba(5, 22, 18, 0) 55%, rgba(5, 22, 18, 0.35) 100%);
}

.hero-couple-photo {
  display: block;
  width: 100%;
  aspect-ratio: 5 / 4;
  height: auto;
  object-fit: cover;
  object-position: center;
}

.hero-couple-meta {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 20px 24px 24px;
}

.hero-couple-title {
  margin: 0;
  font-size: clamp(1.1rem, 2vw, 1.4rem);
  font-weight: 700;
  color: #e6f5f1;
  text-align: center;
  letter-spacing: 0.02em;
}

.hero-discovery-btn {
  color: #f2fcf8;
  background: linear-gradient(135deg, #3c9d87 0%, #2d7463 100%);
  border: 1px solid rgba(193, 232, 222, 0.55);
  padding: 10px 24px;
  font-size: 0.9rem;
}

.hero-photo-card {
  display: grid;
  grid-template-rows: auto auto;
  margin: 0;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(194, 225, 216, 0.35);
  background: linear-gradient(180deg, rgba(14, 52, 44, 0.74), rgba(10, 40, 34, 0.84));
  box-shadow: 0 12px 26px rgba(8, 31, 25, 0.32);
}

.hero-photo-card img {
  display: block;
  width: 100%;
  height: 310px;
  object-fit: contain;
  object-position: center top;
  background: rgba(7, 31, 26, 0.26);
}

.hero-photo-large img {
  aspect-ratio: 3 / 4;
}

.hero-photo-small {
  width: 76%;
  justify-self: center;
}

.hero-photo-small img {
  height: 240px;
  aspect-ratio: 4 / 5;
}

.hero-photo-meta {
  display: grid;
  gap: 8px;
  padding: 10px 12px 12px;
}

.hero-photo-card p {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
  color: #e6f5f1;
  letter-spacing: 0.02em;
}

.hero-photo-meta span {
  color: rgba(230, 245, 241, 0.86);
  font-size: 0.8rem;
  line-height: 1.45;
}

.hero-photo-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.hero-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 999px;
  text-decoration: none;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  transition: transform 0.2s ease, filter 0.2s ease;
}

.hero-consult-btn {
  color: #f2fcf8;
  background: linear-gradient(135deg, #3c9d87 0%, #2d7463 100%);
  border: 1px solid rgba(193, 232, 222, 0.55);
}

.hero-rednote-btn {
  color: #e7f6f2;
  background: linear-gradient(135deg, rgba(26, 73, 61, 0.92) 0%, rgba(16, 52, 43, 0.95) 100%);
  border: 1px solid rgba(168, 214, 202, 0.45);
}

.hero-action-btn:hover,
.hero-action-btn:focus-visible {
  transform: translateY(-1px);
  filter: brightness(1.05);
}

.top-hero-content h1 {
  margin: 0;
  font-size: clamp(2.2rem, 6vw, 5.4rem);
  line-height: 1.06;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.top-hero-content p {
  margin: 20px auto 0;
  max-width: 920px;
  font-size: clamp(1rem, 1.8vw, 1.95rem);
  line-height: 1.5;
  color: rgba(242, 247, 246, 0.86);
}

.top-hero-divider {
  display: block;
  width: 1px;
  height: 130px;
  margin: 44px auto 0;
  background: linear-gradient(to bottom, rgba(238, 244, 242, 0), rgba(238, 244, 242, 0.95), rgba(238, 244, 242, 0));
}

.our-story-section {
  padding: 80px 5%;
  background:
    radial-gradient(circle at 6% 10%, rgba(26, 95, 70, 0.07), transparent 32%),
    radial-gradient(circle at 92% 85%, rgba(205, 135, 60, 0.07), transparent 30%),
    #f5f9f7;
}

.our-story-shell {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 36px;
}

.our-story-header {
  text-align: center;
}

.our-story-kicker {
  margin: 0;
  font-size: clamp(1.3rem, 2.4vw, 1.9rem);
  font-weight: 700;
  color: var(--c-primary-deep);
  letter-spacing: 0.04em;
}

.our-story-body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: clamp(24px, 4vw, 56px);
  align-items: start;
}

.our-story-en,
.our-story-zh {
  display: grid;
  gap: 14px;
}

.our-story-en h2,
.our-story-zh h2 {
  margin: 0;
  font-size: clamp(1.3rem, 2vw, 1.65rem);
  color: var(--c-primary-deep);
  font-weight: 700;
  line-height: 1.25;
}

.our-story-en p,
.our-story-zh p {
  margin: 0;
  color: var(--c-text-body);
  line-height: 1.78;
  font-size: clamp(0.93rem, 1.1vw, 1.02rem);
}

.our-story-en ul,
.our-story-zh ul {
  margin: 0;
  padding-left: 1.4em;
  color: var(--c-text-body);
  line-height: 1.9;
  font-size: clamp(0.93rem, 1.1vw, 1.02rem);
}

.our-story-zh {
  border-left: 2px solid var(--c-accent-soft);
  padding-left: clamp(16px, 2.5vw, 32px);
}

.our-story-zh p,
.our-story-zh ul {
  font-size: clamp(0.98rem, 1.16vw, 1.08rem);
}

.our-story-cta {
  display: flex;
  justify-content: center;
  padding-top: 8px;
}

.our-story-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 36px;
  border-radius: 999px;
  background: linear-gradient(135deg, #3c9d87 0%, #2d7463 100%);
  color: #f2fcf8;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-decoration: none;
  border: 1px solid rgba(193, 232, 222, 0.55);
  transition: transform 0.2s ease, filter 0.2s ease;
}

.our-story-btn:hover,
.our-story-btn:focus-visible {
  transform: translateY(-2px);
  filter: brightness(1.07);
}

.hotspotting-support-section {
  background:
    radial-gradient(circle at 8% 12%, rgba(54, 124, 104, 0.11), transparent 34%),
    radial-gradient(circle at 90% 80%, rgba(197, 130, 67, 0.1), transparent 30%),
    #eef6f3;
}

.hotspotting-shell {
  max-width: 1240px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(280px, 0.9fr) minmax(0, 1.1fr);
  gap: 20px;
  align-items: stretch;
}

.hotspotting-header {
  border-radius: 18px;
  padding: 22px;
  background: linear-gradient(150deg, #1a5f51 0%, #123f35 100%);
  border: 1px solid rgba(146, 188, 174, 0.45);
  color: #edf8f5;
  display: grid;
  align-content: start;
  gap: 10px;
}

.hotspotting-header p {
  margin: 0;
  color: #cde7df;
  font-size: 0.82rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  font-weight: 700;
}

.hotspotting-header h2 {
  margin: 0;
  font-size: clamp(1.55rem, 2.6vw, 2.35rem);
}

.hotspotting-header span {
  color: rgba(237, 248, 245, 0.88);
  line-height: 1.65;
}

.hotspotting-logo {
  margin-top: 10px;
  display: inline-flex;
  align-items: center;
  width: fit-content;
  border-radius: 14px;
  padding: 8px 10px;
  border: 1px solid rgba(189, 225, 215, 0.62);
  background: rgba(235, 248, 243, 0.95);
  text-decoration: none;
}

.hotspotting-logo img {
  display: block;
  height: 54px;
  width: auto;
  max-width: min(100%, 280px);
}

.hotspotting-team-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.hotspotting-profile-card {
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid var(--c-card-border);
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(26, 62, 49, 0.1);
}

.hotspotting-profile-card img {
  width: 100%;
  height: 248px;
  object-fit: cover;
  display: block;
}

.hotspotting-profile-content {
  padding: 14px;
}

.hotspotting-profile-content h3 {
  margin: 0;
  color: var(--c-text-strong);
  font-size: 1.12rem;
}

.hotspotting-role {
  margin: 6px 0 8px;
  color: var(--c-primary);
  font-size: 0.88rem;
  font-weight: 700;
}

.hotspotting-profile-content p {
  margin: 0;
  color: var(--c-text-body);
  line-height: 1.62;
  font-size: 0.92rem;
}

.split-section {
  background: var(--c-bg-soft);
}

.split-section-alt {
  background: var(--c-bg-warm);
}

.split-section-alt .section-container {
  padding-right: 0;
}

.section-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0;
  width: min(1200px, 100%);
  margin: 0;
  margin-left: calc(50% - 50vw);
  padding: 2rem max(16px, calc((100vw - 1200px) / 2));
}

.split-left,
.split-right {
  flex: 0 1 50%;
  max-width: 50%;
  min-width: 320px;
  box-sizing: border-box;
  /* background: #f8faf9; */
  /* border: 1px solid #d9e7e1; */
  border-radius: 14px;
  padding: 1.5rem;
}

.split-tag {
  display: inline-block;
  margin-bottom: 0.75rem;
  color: var(--c-primary);
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.split-left h2 {
  margin: 0 0 0.75rem;
  font-size: 1.8rem;
  line-height: 1.3;
}

.split-left p {
  margin: 0 0 1.25rem;
  color: var(--c-text-body);
  line-height: 1.7;
}

.split-btn {
  border: none;
  border-radius: 10px;
  padding: 0.7rem 1.2rem;
  background: var(--c-primary);
  color: var(--c-on-dark);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
}

.info-card h3 {
  margin-top: 0;
}

.info-card p {
  color: var(--c-text-body);
}

.info-card ul {
  margin: 0.75rem 0 0;
  padding-left: 1.2rem;
  color: var(--c-text-strong);
  line-height: 1.8;
}

.nectar-blocks-video-player__video {
  display: flex;
  justify-content: center;
}

.nectar-blocks-video-player__video video {
  width: 50%;
  max-width: 100%;
  height: auto;
  border-radius: 10px;
}

.split-section-alt .split-right {
  padding: 0;
  border-radius: 0;
}

.split-section-alt .info-card {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

.split-section-alt .nectar-blocks-video-player__video {
  display: block;
  width: 100%;
}

.split-section-alt .nectar-blocks-video-player__video video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0;
}

.numbers-section {
  padding: 72px 6%;
  background:
    radial-gradient(circle at 12% 8%, rgba(31, 107, 79, 0.28), transparent 36%),
    radial-gradient(circle at 86% 80%, rgba(203, 135, 69, 0.2), transparent 30%),
    linear-gradient(120deg, var(--c-dark-1) 0%, #0a2c22 52%, var(--c-dark-2) 100%);
  color: var(--c-on-dark);
}

.numbers-shell {
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(320px, 43%) minmax(0, 57%);
  gap: 44px;
}

.numbers-kicker {
  margin: 8px 0 18px;
  color: var(--c-accent-soft);
  font-size: 0.76rem;
  letter-spacing: 0.26em;
  text-transform: uppercase;
}

.numbers-title {
  margin: 0;
  font-size: clamp(2rem, 4.8vw, 5rem);
  line-height: 0.95;
  font-weight: 300;
}

.numbers-title span {
  color: var(--c-accent-soft);
  font-weight: 400;
}

.numbers-grid {
  margin-top: 34px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.metric-card {
  padding: 18px 18px 14px;
  border-radius: 16px;
  border: 1px solid rgba(140, 187, 176, 0.33);
  background: linear-gradient(145deg, rgba(29, 96, 83, 0.76), rgba(21, 78, 68, 0.8));
  backdrop-filter: blur(2px);
}

.metric-card p {
  margin: 0;
  font-size: 0.85rem;
  letter-spacing: 0.08em;
  color: #cde7e0;
  text-transform: uppercase;
}

.metric-card h3 {
  margin: 10px 0 0;
  font-size: clamp(1.6rem, 2.2vw, 2.2rem);
  font-weight: 400;
  color: var(--c-on-dark);
}

.metric-card h3 span {
  color: var(--c-accent-soft);
}

.metric-wide {
  grid-column: 1 / -1;
}

.numbers-right {
  align-self: end;
  padding: 0;
  border-radius: 0;
  background: transparent;
  border: none;
  min-width: 0;
}

.chart-disclaimer-left {
  margin-top: 18px;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.summary-card {
  padding: 16px;
  border-radius: 14px;
}

.summary-card p {
  margin: 0;
  font-size: 0.8rem;
  color: #274137;
}

.summary-card h4 {
  margin: 8px 0 0;
  font-size: clamp(1.6rem, 2.4vw, 2.1rem);
  font-weight: 500;
  color: #173428;
}

.summary-light {
  background: #e9efe8;
}

.summary-gold {
  background: #9cc8be;
}

.numbers-note {
  margin: 12px 0 0;
  text-align: center;
  font-size: 0.8rem;
  color: #8faf9f;
}

.chart-disclaimer {
  margin-top: 14px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid rgba(140, 187, 176, 0.3);
  background: rgba(11, 79, 71, 0.38);
}

.chart-disclaimer-heading {
  margin: 0 0 6px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #b8dcd4;
}

.chart-disclaimer-body {
  margin: 0;
  font-size: 0.76rem;
  line-height: 1.6;
  color: rgba(180, 214, 205, 0.85);
}

.chart-disclaimer-body a {
  color: #b8dcd4;
  text-decoration: underline;
}

.chart-disclaimer-body a:hover {
  color: #edf8f5;
}

.offer-section {
  padding: 84px 5%;
  background:
    radial-gradient(circle at 12% 10%, rgba(27, 93, 57, 0.08), transparent 32%),
    radial-gradient(circle at 84% 80%, rgba(207, 130, 55, 0.08), transparent 26%),
    var(--c-bg-warm);
}

.offer-shell {
  max-width: 1280px;
  margin: 0 auto;
}

.offer-image-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid var(--c-card-border);
  box-shadow: 0 12px 30px rgba(26, 62, 49, 0.12);
  background: var(--c-card);
}

.offer-image {
  display: block;
  width: min(100%, 1100px);
  max-height: 68vh;
  height: auto;
  object-fit: contain;
}

.offer-header {
  text-align: center;
}

.offer-header h2 {
  margin: 0;
  color: var(--c-primary-deep);
  font-size: clamp(2rem, 4vw, 3.2rem);
  font-weight: 700;
}

.offer-header h2 span {
  color: var(--c-accent);
}

.offer-header p {
  margin: 14px auto 0;
  max-width: 760px;
  color: var(--c-text-muted);
  font-size: 1.05rem;
  line-height: 1.55;
}

.offer-grid {
  margin-top: 54px;
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(360px, 520px) minmax(220px, 1fr);
  align-items: center;
  gap: 18px;
}

.offer-side {
  display: flex;
  flex-direction: column;
  gap: 34px;
}

.offer-item {
  display: grid;
  align-items: center;
  gap: 14px;
}

.offer-left .offer-item {
  grid-template-columns: 1fr 98px;
}

.offer-right .offer-item {
  grid-template-columns: 98px 1fr;
}

.offer-item p {
  margin: 0;
  color: var(--c-text-muted);
  font-size: clamp(1.1rem, 1.55vw, 1.9rem);
  line-height: 1.2;
  font-weight: 600;
}

.offer-left p {
  text-align: right;
}

.offer-icon-hex {
  width: 92px;
  height: 102px;
  clip-path: polygon(25% 4%, 75% 4%, 96% 50%, 75% 96%, 25% 96%, 4% 50%);
  border: 2px solid var(--c-accent);
  background: #f6f3ec;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.offer-icon-hex::before {
  content: '';
  position: absolute;
  inset: 8px;
  clip-path: polygon(25% 4%, 75% 4%, 96% 50%, 75% 96%, 25% 96%, 4% 50%);
  border: 1px solid rgba(194, 122, 58, 0.56);
}

.offer-icon-hex span {
  position: relative;
  color: var(--c-accent);
  font-size: 1.15rem;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.offer-center-wrap {
  display: flex;
  justify-content: center;
  position: relative;
}

.offer-center-wrap::before,
.offer-center-wrap::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 96px;
  height: 2px;
  background: linear-gradient(90deg, #8ab9ad, #5b8f82);
}

.offer-center-wrap::before {
  left: -66px;
}

.offer-center-wrap::after {
  right: -66px;
}

.offer-center-hex {
  width: 420px;
  height: 364px;
  clip-path: polygon(23% 0, 77% 0, 100% 50%, 77% 100%, 23% 100%, 0 50%);
  background: linear-gradient(130deg, #2c7a6a, #23685a 55%, #1b554a);
  box-shadow: 0 12px 30px rgba(9, 37, 27, 0.28);
  padding: 30px;
}

.offer-center-inner {
  width: 100%;
  height: 100%;
  clip-path: polygon(23% 0, 77% 0, 100% 50%, 77% 100%, 23% 100%, 0 50%);
  border: 8px solid var(--c-accent);
  display: flex;
  align-items: center;
  justify-content: center;
}

.offer-center-inner h3 {
  margin: 0;
  color: var(--c-on-dark);
  font-size: clamp(1.8rem, 2.7vw, 3rem);
  font-weight: 600;
}

.sales-team-section {
  padding: 78px 5%;
  background:
    radial-gradient(circle at 10% 15%, rgba(20, 89, 64, 0.08), transparent 35%),
    radial-gradient(circle at 88% 78%, rgba(211, 132, 62, 0.08), transparent 34%),
    var(--c-bg-alt);
}

.sales-team-shell {
  max-width: 1180px;
  margin: 0 auto;
}

.sales-team-header {
  margin-bottom: 28px;
  text-align: center;
}

.sales-team-header h2 {
  margin: 0;
  color: var(--c-primary-deep);
  font-size: clamp(1.9rem, 3.6vw, 3rem);
  line-height: 1.05;
}

.sales-team-list {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.consultant-card {
  display: block;
  border-radius: 14px;
  overflow: hidden;
  background: #fffdfa;
  border: 1px solid color-mix(in srgb, var(--c-accent) 24%, #ffffff 76%);
}

.consultant-photo-wrap {
  aspect-ratio: 4 / 5;
  background: color-mix(in srgb, var(--c-accent) 36%, #ffffff 64%);
}

.consultant-photo {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.consultant-content {
  padding: 12px 12px 14px;
  text-align: center;
}

.consultant-content h3 {
  margin: 0;
  color: #3e2d1f;
  font-size: clamp(1rem, 1.4vw, 1.2rem);
}

.consultant-role {
  margin: 6px 0 0;
  color: var(--c-primary);
  font-weight: 600;
  letter-spacing: 0.01em;
}

.report-section {
  padding: 82px 5%;
  background:
    radial-gradient(circle at 4% 8%, rgba(18, 96, 76, 0.08), transparent 34%),
    radial-gradient(circle at 90% 92%, rgba(214, 141, 68, 0.1), transparent 30%),
    var(--c-bg-warm);
}

.report-shell {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);
  gap: 26px;
}

.report-kicker {
  margin: 0;
  color: var(--c-primary);
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.22em;
  font-weight: 700;
}

.report-left h2 {
  margin: 12px 0 10px;
  color: var(--c-primary-deep);
  font-size: clamp(1.9rem, 3.8vw, 3rem);
}

.report-intro {
  margin: 0;
  color: var(--c-text-body);
  line-height: 1.7;
  max-width: 620px;
}

.report-list {
  margin-top: 24px;
  display: grid;
  gap: 12px;
}

.report-item {
  border: 1px solid var(--c-card-border);
  border-radius: 14px;
  background: var(--c-card);
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: center;
}

.report-item h3 {
  margin: 0;
  color: var(--c-text-strong);
  font-size: 1.08rem;
}

.report-item p {
  margin: 6px 0;
  color: var(--c-text-body);
  line-height: 1.6;
}

.report-item span {
  color: var(--c-accent);
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.03em;
}

.report-apply-btn {
  border: none;
  border-radius: 10px;
  padding: 10px 16px;
  background: var(--c-primary);
  color: var(--c-on-dark);
  font-weight: 600;
  cursor: pointer;
}

.report-right {
  display: flex;
  align-items: stretch;
}

.report-form {
  width: 100%;
  border-radius: 16px;
  background: linear-gradient(160deg, #2b7869 0%, #205f53 100%);
  border: 1px solid rgba(109, 149, 132, 0.35);
  padding: 22px;
  color: #ecf4f0;
  display: grid;
  gap: 12px;
}

.report-form h3 {
  margin: 0 0 6px;
  font-size: 1.26rem;
}

.report-form label {
  display: grid;
  gap: 6px;
  font-size: 0.88rem;
  color: #c3d4cb;
}

.report-form input,
.report-form select,
.report-form textarea {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #84b7aa;
  background: #f7fcfb;
  padding: 10px 12px;
  font-size: 0.95rem;
  color: #29544c;
  box-sizing: border-box;
}

.report-form textarea {
  resize: vertical;
  min-height: 78px;
}

.report-submit-btn {
  margin-top: 4px;
  border: none;
  border-radius: 10px;
  padding: 11px 14px;
  background: var(--c-accent);
  color: var(--c-on-dark);
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
}

.report-success {
  margin: 4px 0 0;
  color: #d8f2ea;
  font-size: 0.88rem;
}

.page-hero {
  padding: 110px 10%;
  text-align: center;
  color: var(--c-on-dark);
  background:
    radial-gradient(circle at 20% 12%, rgba(151, 204, 190, 0.22), transparent 38%),
    linear-gradient(145deg, #14584d 0%, #1a6a5b 55%, #237d69 100%);
}

.page-hero h1 {
  margin: 0;
  font-size: clamp(2rem, 4.2vw, 3.5rem);
}

.page-hero p {
  margin: 12px 0 0;
  color: var(--c-on-dark-muted);
}

.hero-cta {
  margin-top: 20px;
  border-color: var(--c-accent) !important;
  background: var(--c-accent) !important;
  color: var(--c-on-dark) !important;
}

.hero-cta:hover,
.hero-cta:focus {
  border-color: #96c9bc !important;
  background: #96c9bc !important;
}

@media (max-width: 1366px) {
  .top-hero-shell {
    grid-template-columns: minmax(260px, 0.95fr) minmax(300px, 1.05fr);
  }

  .hero-couple-photo {
    aspect-ratio: 16 / 9;
  }

  .offer-image {
    width: min(100%, 980px);
    max-height: 62vh;
  }
}

@media (max-width: 1024px) {
  .top-hero-section {
    min-height: auto;
    padding: 44px 4%;
  }

  .top-hero-shell {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .top-hero-left {
    gap: 8px;
  }

  .top-hero-headline {
    white-space: normal;
  }

  .top-hero-right {
    width: min(100%, 760px);
    justify-self: center;
  }

  .hero-couple-photo {
    aspect-ratio: 3 / 2;
  }

  .sales-team-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {

  .container {
    padding-top: 106px;
  }

  .top-hero-section {
    min-height: auto;
    padding: 36px 4%;
    background-position: center;
  }

  .top-hero-shell {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .top-hero-headline {
    font-size: clamp(1.8rem, 9vw, 2.6rem);
    white-space: normal;
  }

  .top-hero-line-1 {
    font-size: clamp(1rem, 4.2vw, 1.18rem);
  }

  .top-hero-tagline {
    max-width: 100%;
    font-size: clamp(1rem, 4.2vw, 1.18rem);
    line-height: 1.4;
  }

  .top-hero-right {
    width: 100%;
    justify-content: center;
  }

  .hero-couple-card {
    max-width: 100%;
  }

  .hero-couple-photo {
    aspect-ratio: 4 / 3;
  }

  .our-story-section {
    padding: 56px 4%;
  }

  .our-story-body {
    grid-template-columns: 1fr;
    gap: 28px;
  }

  .our-story-zh {
    border-left: none;
    border-top: 2px solid var(--c-accent-soft);
    padding-left: 0;
    padding-top: 24px;
  }

  .hotspotting-support-section {
    padding: 46px 4% 38px;
  }

  .hotspotting-shell {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .hotspotting-team-grid {
    grid-template-columns: 1fr;
  }

  .hotspotting-profile-card img {
    height: 280px;
  }

  .hero-photo-large img {
    aspect-ratio: 3 / 4;
  }

  .hero-photo-large,
  .hero-photo-large img {
    width: 100%;
  }

  .hero-photo-card,
  .hotspotting-profile-card,
  .consultant-card,
  .consultant-photo-wrap,
  .offer-image {
    width: 100%;
  }

  .hero-photo-small img {
    height: 180px;
    aspect-ratio: 4 / 5;
  }

  .hero-photo-small {
    width: 90%;
  }

  .hero-photo-meta {
    gap: 7px;
    padding: 9px 10px 10px;
  }

  .hero-photo-meta span {
    font-size: 0.76rem;
  }

  .hero-action-btn {
    padding: 6px 11px;
    font-size: 0.75rem;
  }

  .section-container {
    flex-direction: column;
    gap: 40px;
  }

  .split-left,
  .split-right {
    flex-basis: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .split-section {
    grid-template-columns: 1fr;
    padding: 1.25rem 1rem;
  }

  .nectar-blocks-video-player__video video {
    width: 100%;
  }

  .split-section-alt .section-container {
    padding-right: 1rem;
  }

  .numbers-section {
    padding: 54px 4%;
  }

  .numbers-shell {
    grid-template-columns: 1fr;
    gap: 22px;
  }

  .numbers-grid,
  .summary-grid {
    grid-template-columns: 1fr;
  }

  .numbers-right {
    padding: 0;
  }

  .offer-section {
    padding: 60px 4%;
  }

  .offer-header p {
    font-size: 0.98rem;
    color: #57756e;
  }

  .offer-grid {
    grid-template-columns: 1fr;
    gap: 28px;
  }

  .offer-center-wrap::before,
  .offer-center-wrap::after {
    display: none;
  }

  .offer-center-hex {
    width: min(84vw, 320px);
    height: min(74vw, 280px);
    padding: 22px;
  }

  .offer-side {
    gap: 16px;
  }

  .offer-left .offer-item,
  .offer-right .offer-item {
    grid-template-columns: 76px 1fr;
    justify-items: start;
  }

  .offer-left p,
  .offer-right p {
    text-align: left;
    order: 2;
  }

  .offer-icon-hex {
    width: 74px;
    height: 84px;
  }

  .sales-team-section {
    padding: 56px 4%;
  }

  .sales-team-header {
    margin-bottom: 24px;
  }

  .sales-team-cta {
    margin-top: 14px;
    padding: 9px 16px;
    font-size: 0.92rem;
  }

  .consultant-card {
    width: 100%;
  }

  .consultant-photo-wrap {
    aspect-ratio: 4 / 5;
  }

  .consultant-content {
    padding: 12px 10px 14px;
  }

  .sales-team-list {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .report-section {
    padding: 56px 4%;
  }

  .report-shell {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .report-item {
    grid-template-columns: 1fr;
  }

  .report-apply-btn {
    width: 100%;
  }

  .report-form {
    padding: 18px;
  }

  .split-btn,
  .report-apply-btn,
  .report-submit-btn,
  .hero-cta {
    background: var(--c-primary-deep);
    color: var(--c-on-dark);
  }

  .page-hero {
    padding: 72px 6%;
  }
}

/* ── Discovery Call Modal ── */
.dc-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(4, 18, 14, 0.62);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  overflow-y: auto;
}

.dc-dialog {
  position: relative;
  width: min(640px, 100%);
  background: #ffffff;
  border-radius: 20px;
  padding: 36px 36px 32px;
  box-shadow: 0 24px 64px rgba(4, 20, 15, 0.28);
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.dc-close {
  position: absolute;
  top: 14px;
  right: 16px;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  font-size: 1.5rem;
  line-height: 1;
  color: var(--c-text-muted);
  cursor: pointer;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;
}

.dc-close:hover {
  background: #f0f4f2;
  color: var(--c-text-strong);
}

.dc-header {
  display: grid;
  gap: 6px;
}

.dc-kicker {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--c-primary);
}

.dc-header h2 {
  margin: 0;
  font-size: clamp(1.3rem, 2.5vw, 1.6rem);
  color: var(--c-text-strong);
  line-height: 1.2;
}

.dc-sub {
  margin: 0;
  color: var(--c-text-body);
  font-size: 0.95rem;
  line-height: 1.55;
}

.dc-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.dc-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.dc-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--c-text-strong);
}

.dc-req {
  color: #c0392b;
}

.dc-field input,
.dc-field select,
.dc-field textarea {
  border: 1px solid var(--c-card-border);
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 0.95rem;
  color: var(--c-text-strong);
  background: #f9fcfb;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  font-family: inherit;
  width: 100%;
  box-sizing: border-box;
}

.dc-field input:focus,
.dc-field select:focus,
.dc-field textarea:focus {
  border-color: var(--c-primary);
  box-shadow: 0 0 0 3px rgba(47, 122, 108, 0.14);
}

.dc-field textarea {
  resize: vertical;
  min-height: 90px;
}

.dc-error {
  font-size: 0.88rem;
  color: #c0392b;
  padding: 8px 12px;
  border-radius: 8px;
  background: #fdf2f2;
  border: 1px solid #f5c6cb;
}

.dc-submit {
  margin-top: 4px;
  padding: 13px 20px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #3c9d87 0%, #2d7463 100%);
  color: #f2fcf8;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  cursor: pointer;
  transition: filter 0.2s, transform 0.15s;
}

.dc-submit:hover:not(:disabled) {
  filter: brightness(1.07);
  transform: translateY(-1px);
}

.dc-submit:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.dc-success {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px 20px;
  border-radius: 14px;
  background: #edf8f3;
  border: 1px solid #a8d9c8;
  color: var(--c-text-strong);
}

.dc-success svg {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  color: var(--c-primary);
  margin-top: 1px;
}

.dc-success strong {
  display: block;
  font-size: 1rem;
  color: var(--c-primary-deep);
  margin-bottom: 4px;
}

.dc-success p {
  margin: 0;
  font-size: 0.92rem;
  color: var(--c-text-body);
  line-height: 1.5;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.22s ease;
}

.modal-fade-enter-active .dc-dialog,
.modal-fade-leave-active .dc-dialog {
  transition: transform 0.22s ease, opacity 0.22s ease;
}

.modal-fade-enter .dc-dialog,
.modal-fade-leave-to .dc-dialog {
  transform: translateY(18px) scale(0.97);
  opacity: 0;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

@media (max-width: 480px) {
  .dc-dialog {
    padding: 24px 18px 22px;
  }

  .dc-row {
    grid-template-columns: 1fr;
  }
}
</style>
